export class Rating {
  constructor({
    id,
    productId,
    userId,
    userName,
    userAvatar,
    rating,
    comment,
    createdAt,
    updatedAt
  }) {
    this.id = id;
    this.productId = productId;
    this.userId = userId;
    this.userName = userName;
    this.userAvatar = userAvatar;
    this.rating = rating;
    this.comment = comment;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }

  static fromFirestore(doc) {
    const data = doc.data();
    return new Rating({
      id: doc.id,
      productId: data.productId,
      userId: data.userId,
      userName: data.userName,
      userAvatar: data.userAvatar,
      rating: data.rating,
      comment: data.comment,
      createdAt: data.createdAt?.toDate(),
      updatedAt: data.updatedAt?.toDate()
    });
  }

  toFirestore() {
    return {
      productId: this.productId,
      userId: this.userId,
      userName: this.userName,
      userAvatar: this.userAvatar,
      rating: this.rating,
      comment: this.comment,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt
    };
  }
} 